export default __webpack_public_path__ + "static/media/phone.ad5d6cac.svg";